import {
  type UseMutationOptions,
  type UseMutationResult,
  type UseQueryOptions,
  useMutation,
  useQuery,
} from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import type { DeleteClaimParams, GetClaimParams, GetClaimResponse } from 'types/api/claim';
import type { SuccessResponse } from 'types/api/common';
import { type ApiError, faksApiInstance as api } from './api';

export const useGetClaimQuery = (
  params?: GetClaimParams,
  options?: UseQueryOptions<GetClaimResponse, AxiosError<ApiError>>
) => {
  return useQuery({
    queryKey: ['invoices', params],
    queryFn: () => api.get<GetClaimResponse>(`invoices/${params?.id}`),
    enabled: !!params?.id,
    ...options,
  });
};

export const useDeleteClaimMutation = (
  options?: UseMutationOptions<SuccessResponse, AxiosError<ApiError>, DeleteClaimParams>
): UseMutationResult<SuccessResponse, AxiosError<ApiError>, DeleteClaimParams> =>
  useMutation({
    mutationFn: (params) => api.delete<SuccessResponse>(`invoices/${params.id}`),
    ...options,
  });
